import {PrismicNextImage} from '@prismicio/next'
import {PrismicRichText} from '@prismicio/react'
import {CustomerStoryContentSliceV2PrimaryCtaItem} from 'prismicio-types'
import {TextLink} from 'src/common/TextLink'

export const CTASection = ({cta}: {cta: CustomerStoryContentSliceV2PrimaryCtaItem}) => {
  return (
    <div className="relative h-full w-full max-lg:order-3 max-lg:mx-auto max-lg:max-w-[600px]">
      <div className="sticky top-[84px] flex flex-col gap-2 max-lg:items-center">
        <PrismicNextImage className="h-10 w-fit" field={cta.image} />
        <PrismicRichText
          field={cta.description}
          components={{
            paragraph: ({children}) => <p className="text-body max-w-[185px] text-grey-550">{children}</p>,
            heading6: ({children}) => <span className="text-body-bold text-moss-black">{children}</span>,
          }}
        />
        <TextLink label={cta.link_label!} field={cta.link} color="neon-550" />
      </div>
    </div>
  )
}
